'use client';
import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useReporter } from '../../reporter';
import { StyledTrustPilot, Header } from './styles.js';
import { TrustPilotCarousel } from './TrustPilotCarousel';
import { loadTrustPilot } from './trustpilot';
import { userViewsTrustPilot } from './events';

export const TrustPilot = ({ header, level }) => {
  const reporter = useReporter();
  const [loaded, setLoaded] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    loadTrustPilot(() => setLoaded(true));
  }, []);

  useEffect(() => {
    const element = containerRef.current;
    if (!element || typeof IntersectionObserver === 'undefined') {
      return undefined;
    }

    //report if half of component is viewed
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
          reporter.tag(userViewsTrustPilot(header));
          observer.disconnect();
        }
      },
      { threshold: [0, 0.25, 0.5, 0.75, 1] },
    );

    observer.observe(element);

    return () => observer.disconnect();
  }, [reporter, header]);

  return (
    <StyledTrustPilot ref={containerRef}>
      <Header as={level}>{header}</Header>
      {loaded && <TrustPilotCarousel />}
    </StyledTrustPilot>
  );
};

TrustPilot.displayName = 'TrustPilot';

TrustPilot.propTypes = {
  header: PropTypes.string.isRequired,
  level: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6']),
};
